module.exports = __webpack_public_path__ + "img/df70a5e.jpg";